(() => {
  'use strict';

  function buildEmbed(root) {
    const holder = root.querySelector('[data-wb-message-embed]');
    if (!holder || holder.dataset.ready) return;

    const frame = holder.querySelector('[data-wb-message-frame]');
    const base = holder.dataset.appUrl || '';
    if (!frame || !base) return;

    const url = new URL(base);
    url.searchParams.set('customer_id', holder.dataset.customerId || '');
    url.searchParams.set('first_name', holder.dataset.firstName || '');
    url.searchParams.set('email', holder.dataset.email || '');
    url.searchParams.set('signature', holder.dataset.signature || '');
    url.searchParams.set('source', 'shopify');

    const current = new URL(window.location.href);
    ['new','product','product_id','variant','subject','thread'].forEach(key => {
      const value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });

    frame.src = url.toString();
    holder.dataset.ready = 'true';

    frame.addEventListener('load', () => {
      const loading = holder.querySelector('.wb-msg__loading');
      if (loading) loading.hidden = true;
    });
  }

  function initDemo(root) {
    const list = root.querySelector('.wb-msg__demo-list');
    const thread = root.querySelector('[data-demo-thread-panel]');
    if (!list || !thread) return;

    root.querySelectorAll('[data-demo-thread]').forEach(btn => {
      btn.addEventListener('click', () => {
        list.hidden = true;
        const toolbar = root.querySelector('.wb-msg__toolbar');
        if (toolbar) toolbar.hidden = true;
        thread.hidden = false;
        thread.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const back = root.querySelector('[data-demo-back]');
    if (back) {
      back.addEventListener('click', () => {
        thread.hidden = true;
        list.hidden = false;
        const toolbar = root.querySelector('.wb-msg__toolbar');
        if (toolbar) toolbar.hidden = false;
      });
    }
  }

  function init(root) {
    buildEmbed(root);
    initDemo(root);
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-wb-messages]').forEach(init);
  }

  window.addEventListener('message', event => {
    const data = event.data;
    if (!data || data.type !== 'wolfborn-messages-height') return;
    const height = Math.max(600, Math.min(4000, Number(data.height) || 850));
    document.querySelectorAll('[data-wb-message-frame]').forEach(frame => {
      if (frame.contentWindow === event.source) frame.style.height = height + 'px';
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', event => boot(event.target));
})()